import React from "react";

export default function LoaderComponent({
  show,
  message = "Loading. Please wait...",
  fullPage = false,
}) {
  if (!show) return null;

  const loaderContent = (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ width: "100%", maxWidth: 250 }}
    >
      {/* Three Dot Loader */}
      <div className="d-flex gap-2 mb-3 justify-content-center align-items-center w-100">
        <div
          className="rounded-circle"
          style={{
            width: 12,
            height: 12,
            backgroundColor: "#3C0008",
            animation: "bounce 1.4s infinite ease-in-out both",
            animationDelay: "-0.32s",
          }}
        ></div>
        <div
          className="rounded-circle"
          style={{
            width: 12,
            height: 12,
            backgroundColor: "#3C0008",
            animation: "bounce 1.4s infinite ease-in-out both",
            animationDelay: "-0.16s",
          }}
        ></div>
        <div
          className="rounded-circle"
          style={{
            width: 12,
            height: 12,
            backgroundColor: "#3C0008",
            animation: "bounce 1.4s infinite ease-in-out both",
          }}
        ></div>
      </div>

      {/* Loading Message */}
      {message && (
        <p className="text-muted mb-0 text-center" style={{ fontSize: "1rem" }}>
          {message}
        </p>
      )}

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
            opacity: 0.5;
          }
          40% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );

  if (fullPage) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          zIndex: 9999,
        }}
      >
        {loaderContent}
      </div>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      {loaderContent}
    </div>
  );
}
